import React, { useState, useEffect, useRef } from 'react';
import '../../styles/Presentation.css';
import '../../styles/HistoriqueMuseum.css';
import ImgH1 from '../../images/H1.jpg';
import ImgH2 from '../../images/H2.jpg';
import ImgH3 from '../../images/H3.jpg';
import ImgH4 from '../../images/H4.jpg';
import ImgH5 from '../../images/H5.jpg';
import ImgH5Bis from '../../images/H5Bis.jpg';
import ImgH6 from '../../images/H6.jpg';
import ImgH7 from '../../images/H7.jpg';
// import ImgH8 from '../../images/H8.jpg';
import ImgH9 from '../../images/H9.jpg';
import ImgH10 from '../../images/H10.jpg';
import ImgH11 from '../../images/H11.png';

const HistoriqueGare = () => {
    const [activeCard, setActiveCard] = useState(null);
    const [centerCard, setCenterCard] = useState(null);
    const timelineRef = useRef(null);

    const timelineEvents = [
        {
            id: 1,
            year: "1843",
            title: "Première idée de la ligne",
            subtitle: "Genèse du projet",
            description: "L'idée d'une ligne Blois Pont de Braye date de 1843 au moins. Un projet ambitieux pour relier les communes de la vallée du Loir.",
            image: ImgH1,
            color: "#0c8f1f"
        },
        {
            id: 2,
            year: "1878",
            title: "Décision officielle",
            subtitle: "7 Septembre 1878",
            description: "La décision de créer une gare à Trôo fut prise le 7 Septembre 1878. Le projet devient réalité après des années d'études.",
            image: ImgH2,
            color: "#0eaf23"
        },
        {
            id: 3,
            year: "1881",
            title: "Inauguration de la ligne",
            subtitle: "20 Novembre 1881",
            description: "En 1881, les travaux vont bon train. La ligne est inaugurée le 20 Novembre 1881, marquant l'entrée de Trôo dans l'ère ferroviaire.",
            image: ImgH5,
            color: "#10cf27"
        },
        {
            id: 4,
            year: "1938",
            title: "Décision d'Arrêt du trafic voyageurs",
            subtitle: "02 Octobre 1938",
            description: "La décision d'arrêt du trafic voyageur est prononcée le 02 Octobre 1938. Le traffic voyageur sera relancé provisoirement du 03 Septembre 1938 au 29 Février 1940 et du 09 Octobre 1940 au 31 Décembre 1940. Le traffic voyageur est arrêté définitivement marquant la fin d'une époque.",
            image: ImgH5Bis,
            color: "#0c8f1f"
        },

        
        {
            id: 5,
            year: "1986",
            title: "Naissance du TTVL",
            subtitle: "Renaissance du projet",
            description: "L'idée du TTVL (Train Touristique de la vallée du Loir) est lancée en 1986 aprés un voyage touristique organisé dans le Vendomois. Un nouveau souffle pour la gare abandonnée.",
            image: ImgH6,
            color: "#0eaf23"
        },
        {
            id: 6,
            year: "1987",
            title: "Création officielle du TTVL",
            subtitle: "Janvier 1987",
            description: "Il est créé en Janvier 1987. La gare de Trôo est alors en piteux état, ses abords envahis par la végétation.",
            image: ImgH3,
            color: "#10cf27"
        },
        {
            id: 7,
            year: "1989",
            title: "Fin du fret",
            subtitle: "Janvier 1989",
            description: "L'arrêt du trafic marchandises en gare de Trôo en Janvier 1989 marque la fin définitive de l'activité ferroviaire commerciale.",
            image: ImgH11,
            color: "#0c8f1f"
        },
        {
            id: 8,
            year: "1990-1992",
            title: "Grande restauration",
            subtitle: "Renaissance par les bénévoles",
            description: "Les abords envahis par la végétation. De 1990 à 1992, les bénévoles vont dégager la voie, débroussailler, débarrasser, remplacer les vitres, restaurer l’intérieur de la gare (plâtres, peintures,..), remettre en état les guichets, aménager les étages et le musée, refaire le quai. Des entreprises seront sollicitées pour une partie des menuiseries ; le remplacement de l’escalier ; l’aménagement de toilettes.",
            image: ImgH4,
            color: "#0eaf23"
        },
        /* {
            id: 9,
            year: "1991",
            title: "Arrivée du X2419",
            subtitle: "1991",
            description: "Arrivée de l'Autorail X2419 en gare de Vendôme.",
            image: ImgH8,
            color: "#10cf27"
        }, */
        {
            id: 9,
            year: "1992",
            title: "Inauguration du TTVL",
            subtitle: "27 Juin 1992",
            description: "La ligne TTVL est inaugurée le 27 Juin 1992. La gare de Trôo trouve sa vocation touristique et patrimoniale.",
            image: ImgH9,
            color: "#10cf27"
        },
        {
            id: 10,
            year: "1998",
            title: "Création de l'Amicale",
            subtitle: "Pérennisation du projet",
            description: "L'amicale de la gare de Trôo est créée en 1998, assurant la continuité et le développement des activités du site.",
            image: ImgH10,
            color: "#0c8f1f"
        }
    ];

    // Fonction pour détecter la carte au centre de l'écran
    const checkCenterCard = () => {
        if (!timelineRef.current) return;
        
        const viewportCenter = window.innerHeight / 2;
        const cards = timelineRef.current.querySelectorAll('.timeline-event');
        let closestCard = null;
        let closestDistance = Infinity;

        cards.forEach((card) => {
            const rect = card.getBoundingClientRect();
            const cardCenter = rect.top + rect.height / 2;
            const distance = Math.abs(cardCenter - viewportCenter);

            if (distance < closestDistance && rect.top < viewportCenter && rect.bottom > viewportCenter) {
                closestDistance = distance;
                closestCard = card.querySelector('.timeline-event-card');
            }
        });

        // Détecter quelle carte est au centre (seulement sur mobile)
        if (window.innerWidth <= 768) {
            const currentCenterId = closestCard ? 
                parseInt(closestCard.closest('.timeline-event').dataset.eventId) : null;
            
            if (currentCenterId !== centerCard) {
                setCenterCard(currentCenterId);
            }
        } else {
            setCenterCard(null);
        }
    };

    // Effect pour le scroll
    useEffect(() => {
        const handleScroll = () => {
            checkCenterCard();
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', checkCenterCard);
        
        // Vérification initiale
        checkCenterCard();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', checkCenterCard);
        };
    }, [centerCard]);

    return (
        <div className="museum-historique" lang="fr">
            <div className="museum-header">
                <div className="timeline-introduction">
                    <h2 className="intro-title">L'Histoire de la Gare de Trôo</h2>
                    <p className="intro-subtitle">De l'idée à la renaissance touristique</p>
                    <p className="intro-description">
                        Découvrez plus de 150 ans d'histoire ferroviaire de la ligne Blois Pont-de-Braye à travers une chronologie interactive.
                    </p>
                    <div className="intro-cta">
                        <span className="cta-text">👇 Explorez la chronologie ci-dessous</span>
                    </div>
                </div>
            </div>

            <div className="historical-timeline" ref={timelineRef}>
                <div className="timeline-line"></div>
                {timelineEvents.map((event, index) => (
                    
                    <div 
                        key={event.id}
                        data-event-id={event.id}
                        className={`timeline-event ${index % 2 === 0 ? 'left' : 'right'} ${
                            activeCard === event.id ? 'active' : ''
                        } ${centerCard === event.id ? 'active' : ''}`}
                    >
                        <div className="timeline-year-marker" style={{backgroundColor: event.color}}>
                            <span className="year-display">{event.year}</span>
                        </div>
                        
                        <div className="timeline-event-card">
                            <div className="event-header" style={{borderLeftColor: event.color}}>
                                <h3 className="event-title">{event.title}</h3>
                                <p className="event-subtitle">{event.subtitle}</p>
                            </div>
                            
                            <div className="event-content">
                                <div className="event-image">
                                    <img src={event.image} alt={event.title} />
                                    <div className="image-year-overlay">{event.year}</div>
                                </div>
                                
                                <div className="event-description">
                                    <p>{event.description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="museum-footer">
                <p className="heritage-note">
                    <em>150 ans d'histoire ferroviaire à la gare de Trôo</em>
                </p>
            </div>
        </div>
    );
};

export default HistoriqueGare;